import {
  LivingTruthSectionWrapper,
  LivingTruthSectionTitleWrapper,
  LivingTruthSectionTitle,
  HeartContainer,
  HeartIcon,
  LivingTruthSectionContent,
  LivingTruthDescription,
  LivingTruthDescriptionSubtext,
  LivingTruthQuote,
  LivingTruthQuoteContainer,
  ctaButtonStyles,
} from './styles';
import { LIVING_TRUTH_SECTION } from './constants';
import { Gapper } from '../../../../../ui/utils';
import CTAButton from '../../../../../ui/ctaButton';
import { useNavigate } from 'react-router-dom';

const LivingTruthSection = () => {
  const navigate = useNavigate();

  const handleExploreServicesClick = () => {
    navigate('/services');
  };
  return (
    <LivingTruthSectionWrapper>
      <LivingTruthSectionTitleWrapper>
        <HeartContainer>
          <HeartIcon />
        </HeartContainer>
        <LivingTruthSectionTitle>{LIVING_TRUTH_SECTION.TITLE}</LivingTruthSectionTitle>
      </LivingTruthSectionTitleWrapper>
      <LivingTruthSectionContent>
        <Gapper gap={40}>
          <Gapper gap={25}>
            <LivingTruthDescription>{LIVING_TRUTH_SECTION.PARAGRAPH_1}</LivingTruthDescription>
            <LivingTruthDescriptionSubtext>
              {LIVING_TRUTH_SECTION.PARAGRAPH_2}
            </LivingTruthDescriptionSubtext>
            <LivingTruthDescriptionSubtext>
              {LIVING_TRUTH_SECTION.PARAGRAPH_3}
            </LivingTruthDescriptionSubtext>
          </Gapper>
          <Gapper gap={32}>
            <LivingTruthQuoteContainer>
              <LivingTruthQuote>{LIVING_TRUTH_SECTION.EMPHASIS_TEXT}</LivingTruthQuote>
            </LivingTruthQuoteContainer>
            <CTAButton
              variant="contained"
              text={LIVING_TRUTH_SECTION.BUTTON_LABEL}
              onClick={handleExploreServicesClick}
              sx={ctaButtonStyles}
            />
          </Gapper>
        </Gapper>
      </LivingTruthSectionContent>
    </LivingTruthSectionWrapper>
  );
};

export default LivingTruthSection;
